<script>
  import { onMount } from 'svelte'
  import Accordion2 from './Accordion2.svelte'
  import { bestofs, fetchFullBestof, lang } from './../store.js'

  onMount(fetchFullBestof)

  let datetime = ''
  let rankingNonFoiler
  let rankingFirstTimer

  const i18n = {
    legend: {
      en: `positions of the #datetime# • 🐣 = first timer - ✔️ = foiler`,
      fr: `positions du #datetime# • 🐣 = bizuth - ✔️ = foil`,
    },

    ranking_full: {
      en: 'Overall ranking',
      fr: 'Classement général',
    },
    ranking_non_foiler: {
      en: 'Non foiler ranking',
      fr: 'Classement bateaux à dérives',
    },
    ranking_first_timer: {
      en: 'First timer ranking',
      fr: 'Classement bizuth ',
    },
  }

  const reportsConfig = {
    // ranking
    ranking_full: {
      unit: '',
      headerClass: 'even',
      title_1: `${i18n.ranking_full[$lang]}`,
    },
    ranking_non_foiler: {
      unit: '',
      headerClass: 'even',
      title_1: `${i18n.ranking_non_foiler[$lang]}`,
    },
    ranking_first_timer: {
      unit: '',
      headerClass: 'even',
      title_1: `${i18n.ranking_first_timer[$lang]}`,
    },
  }

  const unsubscribe = bestofs.subscribe((value) => {
    if (value == undefined || value.length == 0) {
      return
    }
    rankingNonFoiler = value.ranking_full.filter((r) => !r.is_foiler)
    rankingFirstTimer = value.ranking_full.filter((r) => r.is_first_timer)

    const dt = new Date(value.one_hour_speed[0].date)
    datetime = `${dt.toLocaleDateString($lang)} ${dt
      .toLocaleTimeString($lang)
      .slice(0, -3)}`
  })
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    font-family: 'Lato', sans-serif;
    list-style: none;
    text-decoration: none;
  }
  main {
    display: grid;
  }
  /* @media (min-width: 700px) {
      main {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-template-areas:
          '. .'
          '. .'
          '. .';
      }
    } */
  @media (min-width: 1030px) {
    main {
      /* grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr; */
      column-gap: 1em;
      grid-template-areas:
        '. . .'
        '. . .'
        '. . .'
        '. . .';
    }
  }
  .legend {
    text-align: center;
  }
</style>

{#await $bestofs}
  <h1>loading</h1>
{:then data}
  <main>
    <div>
      <Accordion2 data={data.ranking_full} {...reportsConfig.ranking_full} />
    </div>
    <div>
      <Accordion2
        data={rankingNonFoiler}
        {...reportsConfig.ranking_non_foiler} />
    </div>
    <div>
      <Accordion2
        data={rankingFirstTimer}
        {...reportsConfig.ranking_first_timer} />
    </div>
    <div />
    <div class="legend">
      {i18n.legend[$lang].replace('#datetime#', datetime)}
    </div>
  </main>
{/await}
